import BaseModel from '../Base';

export default class User extends BaseModel {
  static entity = 'users';

  static fields() {
    return {
      ...super.fields(),
      current: this.boolean(false),
      username: this.string(''),
      firstName: this.string(''),
      lastName: this.string(''),
      avatarUrl: this.string(''),
      password: this.string(''),
      lastLogin: this.attr('date'),
      locale: this.string('')
    };
  }

  get fullName() {
    return `${this.firstName} ${this.lastName}`;
  }
}
